export const AccCircle = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0007 3.33325C10.8007 3.33325 3.33398 10.7999 3.33398 19.9999C3.33398 29.1999 10.8007 36.6666 20.0007 36.6666C29.2007 36.6666 36.6673 29.1999 36.6673 19.9999C36.6673 10.7999 29.2007 3.33325 20.0007 3.33325ZM20.0007 8.33325C22.7673 8.33325 25.0007 10.5666 25.0007 13.3333C25.0007 16.0999 22.7673 18.3333 20.0007 18.3333C17.234 18.3333 15.0007 16.0999 15.0007 13.3333C15.0007 10.5666 17.234 8.33325 20.0007 8.33325ZM20.0007 31.9999C15.834 31.9999 12.1507 29.8666 10.0007 26.6333C10.0507 23.3166 16.6673 21.4999 20.0007 21.4999C23.3173 21.4999 29.9507 23.3166 30.0007 26.6333C27.8507 29.8666 24.1673 31.9999 20.0007 31.9999Z"
      fill="#ADC6EB"
    />
  </svg>
);
